// NOTE: only modify this file in the /brands/{REACT_APP_BRAND}/brandConfig.ts
const brandConfig = {
	name: 'PlayUp',
	company: 'PlayUp Interactive Pty Ltd',
	urls: {
		responsible_gambling_policy:
			'https://help.playup.com.au/support/solutions/articles/43000613787-playup-responsible-gambling-code',
		terms: 'https://helpcentre.playup.com.au/s/article/General-Terms-and-Conditions',
		privacy_policy: 'https://helpcentre.playup.com.au/s/article/Privacy-Policy',
	},
	eft: {
		bank_name: 'NAB',
		account_name: 'PlayUp Interactive Pty Ltd',
		account_number: '85-274-9935',
		bsb_number: '082-184',
	},
	// NOTE: ideally this should be an env config like the other greenID related informations
	// it was put here to speed things up and avoid creating a new env for all the deployment pipelines
	greenIdRuleset: { AU: 'ruleSetN', NZ: 'ruleSetN' },
	productNav: true,
};

export default brandConfig;
